<script>
import appConfig from "@/app.config";
import Technic from '../tech/list'
import Ara from '../customer/kb_search.vue'
import Admin from './admin'


export default {
  page: {
    title: "Dashboard",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Technic,
    Admin,
    Ara
  },
  data() {
    return {
      title: "Anasayfa",
      items: [],
    };
  },
  computed: {
    roleName(){
      return JSON.parse(localStorage.getItem('userdata')).role_name 
    }
  },
};
</script>

<template>
  <div>
    <Technic v-if="roleName == 'tech'"/>
    <Ara v-if="roleName == 'callcenter' || roleName == 'personel'"/> 
    <Admin v-if="roleName == 'admin' || roleName == 'dealer'"/>
  </div>
</template>
